import type { MediumPathResolver } from './cache.source';

const CACHE_SEARCH_PARAMS = {
    ignoreMethod: true,
    ignoreSearch: true,
    ignoreVary: true,
};

const openCache = (name: string): Promise<Cache> =>
    window.caches === undefined ? Promise.reject('No caches available') : caches.open(name);

const mediaRequestList = (mediaId: string, urlResolver: MediumPathResolver): Promise<Request[]> => {
    const urlFetchList = urlResolver(mediaId);
    const requestList = urlFetchList.map(urlFetch => new Request(urlFetch));
    return Promise.resolve(requestList);
};

const cacheResponsesForRequests = async (
    requests: Request[],
    cache: Cache,
): Promise<Response[]> => {
    const responses = await Promise.all(
        requests.map(request => cache.match(request, CACHE_SEARCH_PARAMS)),
    );
    return responses.filter(response => response !== undefined) as Response[];
};

const deleteMediaIdsFromCache = async (
    cache: Cache,
    mediaIds: string[],
    urlResolver: MediumPathResolver,
): Promise<boolean[]> => {
    const allRequests = await Promise.all(
        mediaIds.map(mediaId => mediaRequestList(mediaId, urlResolver)),
    );

    return Promise.all(
        allRequests.flat().map(request => cache.delete(request, CACHE_SEARCH_PARAMS)),
    );
};

export default Object.freeze({
    openCache,
    mediaRequestList,
    cacheResponsesForRequests,
    deleteMediaIdsFromCache,
});
